// import React, { useState, useEffect } from "react";

// import { getUserName } from "../../../CommonFunction/GetUserInfo";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

// export const Privaterouter = ({ children }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [allow, setAllow] = useState(null);
//   const [loading, setLoading] = useState(true); // Add a loading state
//   const navigate = useNavigate();
//   const path = window.location.pathname;

//   const rights = useSelector((state) => state.userRightsReducer.userRightsData);
//   useEffect(() => {
//     const fetchUserName = async () => {
//       const userName = await getUserName(); // assuming getUserName is asynchronous
//       setAllow(userName);
//       setLoading(false); // Set loading to false after getting the username
//     };

//     fetchUserName();
//   }, []);

//   useEffect(() => {
//     // Only navigate if allow has been explicitly set to a non-truthy value
//     if (
//       /* The `allow` variable is used to determine whether the user is allowed to access the private
//     route. It is initially set to `null` and then updated with the user's name using the
//     `setAllow` function. If `allow` is `null` or `false`, the user is redirected to the login
//     page. If `allow` is `true`, the user is allowed to access the private route and the
//     `children` component is rendered. */
//       allow !== null &&
//       !allow
//     ) {
//       navigate("/login");
//       return;
//     }
//   }, [allow, navigate]);

//   useEffect(() => {
//     if (rights) {
//
//       // If Page_Access is false, navigate to login
//       if (
//         (rights && rights[path] && rights[path].Page_Access === false) ||
//         !rights[path]
//       ) {
//         setIsLoading(true);

//         // ErrorToast("You don't have this page Access");
//         return <div>You Do Not Have This Page Access</div>;
//       }
//     } else {
//       setIsLoading(true);
//     }
//   }, [rights]);

//   if (loading) {
//     return null; // Render nothing while loading
//   }

//   if (isLoading && path !== "/")
//     return <div>You Do Not Have This Page Access</div>;

//   return children;
// };

import React, { useState, useEffect } from "react";
import { getUserName, isEmpty } from "../../../CommonFunction/GetUserInfo";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ErrorToast } from "../ToastComponent/RectHotToast";

export const Privaterouter = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const path = window.location.pathname;
  const rights = useSelector((state) => state.userRightsReducer.userRightsData);

  useEffect(() => {
    (async () => {
      const userName = await getUserName();
      if (!userName) {
        navigate("/login");
        return;
      }

      if (!isEmpty(rights) && path !== "/") {
        if (path.includes("/RequestSupport")) {
          if (!("/RequestSupport" in rights) || rights["/RequestSupport"].Page_Access === false) {
            ErrorToast("You Do Not Have Access To This Page!");
            navigate("/");
          }
        } else if (
          // !(path in rights) || 
          rights[path]?.Page_Access === false) {
          ErrorToast("You Do Not Have Access To This Page!");
          navigate("/");
        }
      }

      setLoading(false);
    })();
  }, [rights, navigate, path]);

  if (loading) return null;
  // if (isAccessDenied) return <div>You Do Not Have This Page Access</div>;

  return children;
};
